<template>
  <div id="contenedor-editar-infraestructura-ubicacion">
    <v-form v-model="formularioValido" ref="editarInfraestructuraUbicacion">
      <v-card>
        <v-card-title>
          Editar Ubicación
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Punto A
            </v-col>
            <v-col cols="6">
              <custom-input
                v-model="ubicacion.latitudPuntoA"
                label="Latitud"
                :rules="[mixReglas.requerido]"
                prepend-inner-icon="mdi-map-marker"
              >
              </custom-input>
            </v-col>
            <v-col cols="6">
              <custom-input
                v-model="ubicacion.longitudPuntoA"
                label="Longitud"
                :rules="[mixReglas.requerido]"
                prepend-inner-icon="mdi-map-marker"
              >
              </custom-input>
            </v-col>
            <v-col cols="12"> Punto B <b>(Opcional)</b> </v-col>
            <v-col cols="6">
              <custom-input
                v-model="ubicacion.latitudPuntoB"
                label="Latitud"
                prepend-inner-icon="mdi-map-marker"
              >
              </custom-input>
            </v-col>
            <v-col cols="6">
              <custom-input
                v-model="ubicacion.longitudPuntoB"
                label="Longitud"
                prepend-inner-icon="mdi-map-marker"
              >
              </custom-input>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="actualizarInfraestructura"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomInput from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'EditarInfraestructuraUbicacion',
  props: {
    ubicacionEditar: {
      type: Object,
      requirted: true,
    },
  },
  components: {
    CustomButton,
    CustomInput,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      ubicacion: {
        descripcion: this.ubicacionEditar.descripcion,
        latitudPuntoA: this.ubicacionEditar.latitudPuntoA,
        longitudPuntoA: this.ubicacionEditar.longitudPuntoA,
        latitudPuntoB: this.ubicacionEditar.latitudPuntoB,
        longitudPuntoB: this.ubicacionEditar.longitudPuntoB,
      },
    };
  },
  methods: {
    actualizarInfraestructura() {
      this.$emit('editarUbicacion', this.ubicacion);
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss"></style>
